import React, { useState } from "react";
import { MainLayout, InnerLayout } from "../styles/Layouts";
import SectionTitle from "../Components/SectionTitle";
import portfolios from "../data/portfolios";
import ProjectCard from "../Components/ProjectCard";
import FilterButtons from "../Components/FilterButtons";
import { PageTransition, FadeIn } from "../Components/AnimatedComponents";

const allButtons = [
  "All",
  ...Array.from(new Set(portfolios.map((item) => item.category))),
];

const ProjectsPage: React.FC = () => {
  const [menuItem, setMenuItems] = useState(portfolios);
  const [activeFilter, setActiveFilter] = useState("All");

  const filter = (category: string) => {
    setActiveFilter(category);
    if (category === "All") {
      setMenuItems(portfolios);
      return;
    }
    const filteredData = portfolios.filter(
      (item) => item.category === category,
    );
    setMenuItems(filteredData);
  };

  return (
    <PageTransition>
      <MainLayout>
        <FadeIn direction="up">
          <SectionTitle title={"Projects"} span={"projects"} />
        </FadeIn>
        <InnerLayout>
          <FadeIn direction="up" delay={0.1}>
            <FilterButtons
              filter={filter}
              buttons={allButtons}
              activeFilter={activeFilter}
            />
          </FadeIn>
          <ProjectCard menuItem={menuItem} />
        </InnerLayout>
      </MainLayout>
    </PageTransition>
  );
};

export default ProjectsPage;
